var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJacLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 23,
    viewBox: "0 0 78 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23395 18.9267H12.9736C14.9892 18.9267 16.9231 18.0278 18.2033 16.4753L27.3825 5.33488C27.7911 4.81735 27.4915 4.05469 26.8106 4.05469H22.9155C22.5069 4.05469 22.1256 4.24535 21.8804 4.54497L13.0008 15.3585C11.4755 17.2107 9.70501 17.5103 7.989 17.5103L2.07833 17.5376C1.88767 17.5376 1.64252 17.6738 1.53357 17.8372L1.04328 18.5726C0.93433 18.7088 1.04328 18.9267 1.23395 18.9267Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5632 17.8672L27.3299 11.9565C28.4194 10.5946 30.081 9.80469 31.8242 9.80469H38.6882C38.8517 9.80469 38.9606 9.83193 39.0423 9.96812L39.5054 10.6218C39.6688 10.8397 39.5054 11.1394 39.233 11.1394H34.7659C33.404 11.1394 32.0966 11.7658 31.225 12.8281L26.7034 18.3847C26.4311 18.7388 25.9952 18.9295 25.5322 18.9295H22.9718C22.4815 18.9295 22.2092 18.303 22.5632 17.8672Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8152 5.38915H36.9983C38.6053 5.38915 40.1307 6.09734 41.1385 7.35029L50.1816 18.3545C50.5084 18.7631 50.9987 18.981 51.5162 18.981H55.2478C55.9016 18.981 56.2557 18.2183 55.8471 17.728L46.3682 6.26077C45.197 4.81714 43.3175 4 40.5665 4H31.6324C31.4145 4 31.1966 4.10895 31.0876 4.29962L30.5701 5.03505C30.4884 5.17124 30.5973 5.38915 30.8152 5.38915Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0295 4.24554L69.547 4.98097C69.6832 5.1444 69.547 5.41678 69.3291 5.41678H58.3794C57.7257 5.41678 57.3988 6.09774 57.9163 6.72421L64.9165 15.2497C66.1967 16.884 67.7221 17.5377 70.119 17.5377H75.9207C76.1386 17.5377 76.3565 17.6467 76.4655 17.8374L76.9558 18.5456C77.0647 18.709 76.9558 18.9269 76.7651 18.9269L64.8893 18.9541C62.9009 18.9269 61.3211 18.1642 59.7413 16.421L50.6437 5.36231C50.2079 4.84478 50.5348 4.02764 51.1885 4.02764H68.5664C68.7299 4.0004 68.9205 4.10935 69.0295 4.24554Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJacLogoWhite);
export default ForwardRef;